import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';

import BackButton from '../custom/BackButton';
import PDFViewer from '.';

interface Props {
    link: string;
    title?: string;
    modal: boolean;
    setModal: (state: boolean) => void;

}

export default function PDFViewerModal ({
    link,
    title,
    modal,
    setModal
}: Props) {

    const toggle = () => setModal(!modal);

    return (
        <CustomModal isOpen={modal} toggle={toggle}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>View PDF {title}</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <PDFViewer 
                    link={link}
                />
            </ModalBody>
        </CustomModal>
    );
}

const CustomModal = styled(Modal)`
    max-width: 800px;
`;

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;
